import { useTranslations } from '@altermaind/core/i18n';
import { Box, Typography, Button, Svg } from '@altermaind/web/ui';
import { useDialog } from '@/_shared/hooks';
import { useLogin } from '@/login/state';

export const DialogLogout = () => {
  const t = useTranslations('dialogLogout');
  const { closeDialog, Dialog, isOpen } = useDialog('logout');

  const { logout } = useLogin();

  return (
    <Dialog maxWidth='700px' open={isOpen} title={undefined} onClose={closeDialog} closeButton>
      <Box display='flex' flexDirection='column'>
        <Typography mt='none' variant='h3' color='primary/text' textAlign='center'>
          {t('title')}
        </Typography>
      </Box>

      <Box mb='xs' mt='m' width='100%'>
        <Typography variant='p2/light' textAlign='center' mb='m'>
          {t('description')}
        </Typography>
        <Typography variant='p2/light' fontWeight='500' textAlign='center'>
          {t('confirmText')}
        </Typography>
      </Box>

      <Box mt='l' display='flex' flexDirection='row'>
        <Box mr='s' alignItems='center' alignContent='center' display='flex' flexDirection='row'>
          <Svg name='close' size='s' />
          <Button height='none' variant='link/primary' onClick={closeDialog}>
            {t('cancel')}
          </Button>
        </Box>
        <Button variant='primary' onClick={logout}>
          {t('confirm')}
        </Button>
      </Box>
    </Dialog>
  );
};
